var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form-control form-control_size_full form-control_white",staticStyle:{"text-align":"left","color":"darkgray"},attrs:{"type":"button","disabled":_vm.disabled,"data-qa":"add-button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }